export default "__VITE_ASSET__C8l90MDi__"